(() => {
  const FLAGS = (() => {
    const el = document.getElementById('loow-variant-flags');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch { return {}; }
  })();

  const NOTE_SEL = '[data-loow-no-restock-note]';
  const WIDGET_SEL = '.gw-button-widget';

  function getVariantId() {
    // Først: variant input i produkt-form
    const inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    for (const inp of inputs) {
      if (inp && inp.value) return String(inp.value);
    }
    // Fallback: URL ?variant=
    const urlVid = new URL(location.href).searchParams.get('variant');
    return urlVid ? String(urlVid) : null;
  }

  function setNoteVisible(show) {
    document.querySelectorAll(NOTE_SEL).forEach((note) => {
      note.hidden = !show;
      note.style.display = show ? '' : 'none';
    });
  }

  // Vi skjuler kun widget’en “hårdt”, når vi selv har besluttet det – og markerer det
  function hideWidget() {
    document.querySelectorAll(WIDGET_SEL).forEach((el) => {
      if (el.dataset.loowHidden === '1') return;
      el.dataset.loowHidden = '1';
      el.dataset.loowPrevDisplay = el.style.display || '';
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });
  }

  // Restore kun hvis vi selv tidligere har skjult den (så vi ikke kæmper mod app’en)
  function restoreWidget() {
    document.querySelectorAll(WIDGET_SEL).forEach((el) => {
      if (el.dataset.loowHidden !== '1') return;
      const prev = el.dataset.loowPrevDisplay || '';
      if (prev) el.style.display = prev;
      else el.style.removeProperty('display');
      delete el.dataset.loowHidden;
      delete el.dataset.loowPrevDisplay;
      el.setAttribute('aria-hidden', 'false');
    });
  }

  function update() {
    const vid = getVariantId();
    if (!vid) return;

    const data = FLAGS[vid];

    // Hvis vi ikke har data for varianten: skjul note og restore evt. widget vi selv skjulte
    if (!data) {
      setNoteVisible(false);
      restoreWidget();
      return;
    }

    // Kun: aldrig på lager igen + udsolgt
    const block = (data.never_restock === true) && (data.available === false);

    setNoteVisible(block);
    if (block) hideWidget();
    else restoreWidget();
  }

  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest('form[action*="/cart/add"]')) update();
  });
  window.addEventListener('popstate', update);
  document.addEventListener('variant:change', update);

  // App’en kan injecte widget efter load
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
})();
